module.exports = __webpack_public_path__ + "img/4acbb06.jpg";